// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__1-v--","links":"NavBar_links__fQuaj","link":"NavBar_link__ruV-f","current":"NavBar_current__fxVex"};